import { Component, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { Master } from '../../../../models/master.model';
import { FormGroup, FormControl, Validators } from '@angular/forms';

import { Router, ActivatedRoute, Params } from '@angular/router';
import { DepartmentService } from '../../../../services/department.service';
import { GroupService } from '../../../../services/group.service';
import { MediaAttributeService } from '../../../../services/media-attribute.service';
import { MasterService } from '../../../../services/master.service';

import { Group } from '../../../../models/group.model';
import { MediaAttribute } from '../../../../models/media-attribute.model';
import { Department } from '../../../../models/department.model';
import { Subscription } from 'rxjs/Subscription';
import { Subject } from 'rxjs/Subject';
import { ClientService } from '../../../../services/client.service';
import { Client } from '../../../../models/client.model';

import { Select2OptionData } from 'ng2-select2';
import { SubgroupService } from '../../../../services/subgroup.service';
import { Subgroup } from '../../../../models/subgroup.model';

@Component({
  selector: 'app-master-edit',
  templateUrl: './master-edit.component.html',
  styleUrls: ['./master-edit.component.css']
})
export class MasterEditComponent implements OnInit, OnDestroy {
  loading = false;
  id: number;
  editMode = false;
  backUrl: string;
  category: string;
  category_id: number;
  duplicateMode = false;
  categoryHolder: any;

  subscription: Subscription;
  subscriptionGroup: Subscription;
  subscriptionMediaAttribute: Subscription;
  subscriptionDepartment: Subscription;
  subscriptionClient: Subscription;
  subscriptionResponse: Subscription;

  subgroupsSubscription: Subscription;

  categories = {
    'enewsletter': 1,
    'buyer-match': 2,
    'quick-enquiry': 3,
    'brochure': 4,
    'property-guide': 5,
    'social-media': 6,
    'email-signature': 7,
    'dl-card': 8,
    'sign-board': 9
  };

  master: Master;
  masterForm: FormGroup;

  groups: Group[];
  mediaAttributes: MediaAttribute[];
  departments: Department[];
  clients: Client[];
  subgroups: Subgroup[];

  master_title = '';

  s2ClientValue = 0;
  s2ClientData: Array<Select2OptionData>;
  s2ClientOptions: Select2Options;

  @ViewChild('fileIcon') fileIcon: ElementRef;

  constructor(private masterService: MasterService,
    private groupService: GroupService,
    private mediaAttributeService: MediaAttributeService,
    private departmentService: DepartmentService,
    private clientService: ClientService,
    private route: ActivatedRoute,
    private router: Router,
    private subgroupService: SubgroupService) { }

  ngOnInit() {
    this.route.params.subscribe(
      (params: Params) => {
        this.id = +params['id'];
        this.editMode = params['id'] != null;
        this.duplicateMode = params['dupe'];
        this.editMode = params['id'] != null;
        if (this.duplicateMode) {
          this.backUrl = '../../../';
        } else {
          this.backUrl = this.editMode ? '../../' : '../';
        }

        this.category = params['type'];
        this.category_id = this.categories[this.category];

        if (this.id) {
          this.loading = true;
        }
      }
    );

    this.groupService.httpGetGroups();
    this.mediaAttributeService.httpGetMediaAttributes();
    this.departmentService.httpGetDepartments();
      this.clientService.httpGetClients({}, 'list');
    this.subgroupService.httpGetSubgroups();

    this.subscriptionGroup = this.groupService.groupsChanged.subscribe(
      (groups: Group[]) => {
        this.groups = groups;
      }
    );

    this.subscriptionMediaAttribute = this.mediaAttributeService.mediaAttributesChanged.subscribe(
      (mediaAttributes: MediaAttribute[]) => {
        this.mediaAttributes = mediaAttributes;
      }
    );

    this.subscriptionDepartment = this.departmentService.departmentsChanged.subscribe(
      (departments: Department[]) => {
        this.departments = departments;
      }
    );

    this.subgroupsSubscription = this.subgroupService.subgroupGetAll.subscribe(
      (subgroups: any) => {
        if ( typeof subgroups !== 'undefined' && subgroups.status === 'success' ) {
          this.subgroups = subgroups.data;
        }
      }
    );

    this.subscriptionClient = this.clientService.clientsChanged.subscribe(
      (clients: Client[]) => {
        if (clients.length > 0) {
          this.s2ClientData =  <any>clients.map(
            (obj) => {
              return {id: obj.ID, text: (obj.name ? obj.name : obj.company_name) + ' (' + obj.office_id + ')'};
            }
          );

          if (this.id) {
            this.masterService.httpGetMaster(this.id);
          }

          this.s2ClientData.unshift({id: '0', text: 'All'});
        }
      }
    );

    this.s2ClientOptions = {
      width: '100%',
      placeholder: 'Select a Client'
    };

    this.subscription = this.masterService.masterChanged.subscribe(
      (master: Master) => {
        this.master = master;

        if ( this.editMode && typeof master !== 'undefined' && typeof master.ID !== 'undefined' ) {
          this.categoryHolder = master.category_id;
          this.loading = false;
          this.initFormEdit();
        }
      }
    );

    this.subscriptionResponse = this.masterService.masterOperation.subscribe(
      (master: Master) => {
        if ( typeof master.ID !== 'undefined' ) {
          this.loading = false;
          this.router.navigate([this.backUrl], {relativeTo: this.route});
        }
      }
    );

    this.initForm();
  }

  private initForm() {
    this.masterForm = new FormGroup({
      'title': new FormControl('', Validators.required),
      'description': new FormControl(''),
      'provider': new FormControl('all', Validators.required),
      'group_id': new FormControl(1, Validators.required),
      'media_attribute_id': new FormControl(1, Validators.required),
      'department_id': new FormControl(1, Validators.required),
      'client_id': new FormControl(0, Validators.required),
      'subgroup_id': new FormControl(0),
      'is_active': new FormControl(1, Validators.required),
      'show_element': new FormControl(0, Validators.required),
      'icon': new FormControl(''),
      'enable_ckeditor': new FormControl('1', Validators.required),
      'enable_contenteditable': new FormControl('1', Validators.required),
      'validation_code': new FormControl('')
    });
  }

  private initFormEdit() {
    this.s2ClientValue = this.master.client_id;
    this.master_title = this.master.title;
    this.masterForm.patchValue({
      'title': this.master.title,
      'description': this.master.description,
      'provider': this.master.provider,
      'group_id': this.master.group_id,
      'media_attribute_id': this.master.media_attribute_id,
      'department_id': this.master.department_id,
      'client_id': this.master.client_id,
      'subgroup_id': this.master.subgroup_id,
      'is_active': (this.duplicateMode) ? 0 : this.master.is_active,
      'show_element': this.master.show_element,
      'icon': this.master.icon,
      'enable_ckeditor': this.master.enable_ckeditor,
      'enable_contenteditable': this.master.enable_contenteditable,
      'validation_code': this.master.validation_code
    });
  }

  patchForm(field, value) {
    if (field === 'client_id') {
      this.masterForm.patchValue({'client_id': value});
      this.s2ClientValue = value;
    }
  }

  onSubmit() {
    const masterValues = this.masterForm.value;

    const icon = this.fileIcon.nativeElement;
    this.loading = true;

    if (icon.files.length > 0) {
      masterValues['iconFile'] = icon.files[0];
    }

    if ( this.editMode && typeof this.duplicateMode === 'undefined' ) {
      this.masterService.httpPutMaster(this.id, masterValues);
    } else if (this.duplicateMode) {
      masterValues['category_id'] = this.categoryHolder;

      this.masterService.httpPostMaster(masterValues);
    } else {
      masterValues['category_id'] = this.category_id;

      this.masterService.httpPostMaster(masterValues);
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
    this.subscriptionGroup.unsubscribe();
    this.subscriptionMediaAttribute.unsubscribe();
    this.subscriptionDepartment.unsubscribe();
    this.subscriptionClient.unsubscribe();
    this.subscriptionResponse.unsubscribe();
  }

}



// WEBPACK FOOTER //
// ./src/app/admin/templates/masters/master-edit/master-edit.component.ts